const $ = require("jquery");
require("../../components/ui-components/reviewsCarousel"); // shared reviews block carousel (requires slick itself)
require("../../components/ui-components/clientsCarousel");  // vertical-lp clients block: sideways scroller at tablet/mobile
// Business-type cards stack on mobile on every category page (docs/category-page-rules.md, rule 3),
// so the former subcatCarousel scroller is no longer loaded.
const { initReserveTallestTabPanel } = require("../../components/ui-components/askSimplyPanels");

$(function () {
    initReserveTallestTabPanel();
});
